import { motion } from "framer-motion";
import { useLang } from "../../context/LanguageContext";
import { whyChoose, images } from "../../data/content";

const ease = [0.22, 1, 0.36, 1];

const WhyChoose = () => {
  const { isAr, t } = useLang();
  return (
    <section
      className="relative bg-bg-ivory py-[120px] md:py-[180px]"
      data-testid="why-section"
    >
      <div className="max-w-[1760px] mx-auto px-6 md:px-10 lg:px-14">
        <div className="flex justify-between items-center text-brand-green/65 mb-16">
          <span className="page-meta">— 14</span>
          <span className="page-meta">{t("لماذا نختار بيج براند", "Why Choose BigBrand")}</span>
        </div>

        <div className="grid grid-cols-12 gap-x-10 gap-y-16">
          <motion.div
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            viewport={{ once: true }}
            transition={{ duration: 1.4, ease }}
            className="col-span-12 md:col-span-5"
          >
            <div className="md:sticky md:top-[120px]">
              <div className={`${isAr ? "label-meta-ar" : "label-meta"} text-brand-green/55 mb-5`}>
                {t("[ لماذا نختار بيج براند ]", "[ WHY CHOOSE BIGBRAND ]")}
              </div>
              <h3
                className={`${isAr ? "arabic-title" : "serif-title"} text-brand-green mb-10`}
                style={{ fontSize: isAr ? "clamp(36px, 4.2vw, 60px)" : "clamp(42px, 4.8vw, 80px)" }}
              >
                {isAr ? "لماذا نختار بيج براند" : (<>Why <em className="font-light">Choose</em><br />BigBrand</>)}
              </h3>

              <div className="relative overflow-hidden">
                <img
                  src={images.doorShowroom}
                  alt={t("غرفة عرض الأبواب الفاخرة", "Premium door showroom")}
                  className="w-full h-[420px] object-cover"
                  style={{ filter: "saturate(0.9)" }}
                />
                <div className="absolute bottom-4 left-4 right-4 flex justify-between text-bg-ivory">
                  <span className="label-meta">— PREMIUM FINISH</span>
                  <span className="page-meta">BigBrand</span>
                </div>
              </div>
            </div>
          </motion.div>

          <div className="col-span-12 md:col-span-7">
            {whyChoose.map((r, i) => (
              <motion.div
                key={i}
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-80px" }}
                transition={{ duration: 0.9, ease, delay: i * 0.06 }}
                className="group py-8 border-b border-brand-green/15 transition-all duration-700 cursor-hover hover:bg-[#E8D3C3]/30 hover:px-4 hover:-mx-2"
                data-testid={`why-item-${i}`}
              >
                <div className="grid grid-cols-12 gap-4 items-baseline">
                  <div className="col-span-2 md:col-span-1 page-meta text-brand-green/65">
                    {String(i + 1).padStart(2, "0")}
                  </div>
                  <div className="col-span-10 md:col-span-11">
                    <div
                      className={`${isAr ? "arabic-title" : "serif-title italic font-light"} text-brand-green mb-2`}
                      style={{ fontSize: isAr ? 22 : 28 }}
                      dir={isAr ? "rtl" : "ltr"}
                    >
                      {isAr ? r.ar_t : r.en_t}
                    </div>
                    <div
                      className={`${isAr ? "arabic-title" : ""} text-brand-green/70`}
                      style={{ fontSize: 14.5, lineHeight: 1.75, fontWeight: 400 }}
                      dir={isAr ? "rtl" : "ltr"}
                    >
                      {isAr ? r.ar_d : r.en_d}
                    </div>
                  </div>
                </div>
              </motion.div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default WhyChoose;
